import { render, staticRenderFns } from "./InvoicesCDEKTable.vue?vue&type=template&id=d2486e30&scoped=true"
import script from "./InvoicesCDEKTable.vue?vue&type=script&lang=js"
export * from "./InvoicesCDEKTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesCDEKTable.vue?vue&type=style&index=0&id=d2486e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2486e30",
  null
  
)

export default component.exports